import { useSelector } from 'react-redux';

export const getLoggedUserUser = () => {
  // logged info
  const authState = useSelector((state) => state?.user || {});
  return authState?.user || {};
};
